import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { IModelUserDto, IUserDto } from '@adex/shared/models/dto/user.dto'
import { ISetPasswordDto } from '@adex/shared/models/dto/set-password.dto'
import { ITokenDto } from '@adex/shared/models/dto/token.dto'
import { IResetPasswordDto } from '@adex/shared/models/dto/reset-password.dto'
import { ILoginDto } from '@adex/shared/models/dto/login.dto'
import { IEmailDto } from '@adex/shared/models/dto/email.dto'
import { urls } from '@adex/shared/network/urls'
import { NetworkResponse } from '@adex/shared/network/response'
import { map } from 'rxjs/operators'
import { userDtoToUser } from '../utils/auth-data-converter'
import { IUser } from '@adex/shared/models/user'


@Injectable()
export class AuthNetworkService {

  constructor(private readonly http: HttpClient) {
  }

  public postUserCreate(userDto: IModelUserDto): Observable<void> {
    return this.http.post<void>(urls.user.create, userDto)
  }

  public getUserMe(): Observable<IUser> {
    return this.http.get<NetworkResponse<{ user: IUserDto }>>(urls.user.me).pipe(
      map((model) => userDtoToUser(model))
    )
  }

  public postUserConfirmEmail(token: ITokenDto): Observable<void> {
    return this.http.post<void>(urls.user.confirmEmail, token)
  }

  public postSetPassword(password: ISetPasswordDto): Observable<void> {
    return this.http.post<void>(urls.user.setPassword, password)
  }

  public postResetPassword(email: IEmailDto): Observable<void> {
    return this.http.post<void>(urls.user.resetPassword, email)
  }

  public postResetPasswordCheckToken(token: ITokenDto): Observable<void> {
    return this.http.post<void>(urls.user.resetPasswordCheckToken, token)
  }

  public postResetPasswordSetPassword(password: IResetPasswordDto): Observable<void> {
    return this.http.post<void>(urls.user.resetPasswordSetPassword, password)
  }

  public postLogin(loginDto: ILoginDto): Observable<void> {
    return this.http.post<void>(urls.auth.login, loginDto)
  }

  public loginGoogle(data: any): Observable<void> {
    return this.http.get<void>(`${urls.auth.googleAuthLogin}?redirect_uri=${data.uri}&code=${data.code}`)
  }
}
